import { Offer } from 'common/contracts';
import Decimal from 'decimal.js';

export const getPaidPriceDisplay = (offer: Offer): string => {
  const productsSequence = offer.productsSequence;

  if (!Array.isArray(productsSequence) || productsSequence.length === 0) {
    return '-';
  }

  const priceInUsdCents = productsSequence[0].priceInUsdCents;

  if (priceInUsdCents === 0) {
    return 'Free';
  }

  return `$${new Decimal(priceInUsdCents).div(100).toFixed(2)}`;
};
